import { useMutation } from '@tanstack/react-query';
import { HomeInquiryRequest } from '../models/panorama.models';
import { postAuthenticated } from './api';

export const useMutateHomeInquiry = () => {
  const url = `home/inquiry`;
  return useMutation({
    mutationKey: ['home-inquiry'],
    mutationFn: async (request: HomeInquiryRequest) => {
      const body = JSON.stringify(request);
      return postAuthenticated<HomeInquiryRequest>(url, body);
    },
  });
};
